import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EventCard } from "@/components/EventCard";
import { StatusBadge } from "@/components/ApplicantRow";
import { SponsorCard } from "@/components/SponsorCard";
import { ChatEmailToggle, EventEmailToggle, UnlockEmailToggle } from "@/components/ChatEmailToggle";

const ClientDash = () => {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events/mine").then((r) => setEvents(r.data)); }, []);
  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-6 mt-12">
        <h2 className="font-serif text-3xl">I tuoi eventi</h2>
        <Link to="/eventi/nuovo" className="btn-gold" data-testid="dashboard-create-event-button">Nuovo evento</Link>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8" data-testid="dashboard-events-grid">
        {(events || []).map((e, i) => <EventCard key={e.id} e={e} index={i} />)}
      </div>
      {events?.length === 0 && <p className="text-neutral-500 border border-white/5 p-12 text-center mt-8" data-testid="dashboard-no-events">Non hai ancora pubblicato eventi.</p>}
      <div className="mt-16 flex flex-wrap gap-4">
        <Link to="/cerca" className="btn-ghost" data-testid="dashboard-search-link">Cerca hostess per città</Link>
      </div>
    </>
  );
};

const HostessDash = () => {
  const [apps, setApps] = useState(null);
  useEffect(() => { api.get("/applications/mine").then((r) => setApps(r.data)); }, []);
  return (
    <>
      <div className="flex flex-wrap gap-4 mt-12">
        <Link to="/profilo" className="btn-gold" data-testid="dashboard-edit-profile-button">Modifica profilo</Link>
        <Link to="/eventi" className="btn-ghost" data-testid="dashboard-browse-events-button">Sfoglia eventi</Link>
      </div>
      <SponsorCard />
      <h2 className="font-serif text-3xl mt-16">Le tue candidature</h2>
      <div className="mt-8 divide-y divide-white/5 border-y border-white/5" data-testid="dashboard-applications-list">
        {(apps || []).map((a) => a.event && (
          <Link key={a.id} to={`/eventi/${a.event.id}`} className="flex flex-wrap items-center justify-between gap-4 py-5 hover:bg-white/[0.02] px-2 transition-colors" data-testid={`dashboard-application-${a.id}`}>
            <div>
              <p className="font-serif text-2xl">{a.event.title}</p>
              <p className="text-xs text-neutral-500 mt-1">{a.event.city} · {formatDate(a.event.date)} · {a.event.client_name}</p>
            </div>
            <StatusBadge status={a.status} testid={`dashboard-application-status-${a.id}`} />
          </Link>
        ))}
        {apps?.length === 0 && <p className="text-neutral-500 py-12 text-center" data-testid="dashboard-no-applications">Nessuna candidatura. Sfoglia gli eventi aperti e candidati.</p>}
      </div>
    </>
  );
};

export default function Dashboard() {
  const { user } = useAuth();
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 pt-16" data-testid="dashboard-page">
      <p className="eyebrow">{user.role === "hostess" ? "Area hostess" : "Area cliente"}</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">Ciao, {user.name.split(" ")[0]}</h1>
      {user.role === "hostess" ? <HostessDash /> : <ClientDash />}
      <ChatEmailToggle />
      {user.role === "hostess" && <><EventEmailToggle /><UnlockEmailToggle /></>}
    </main>
  );
}
